import classNames from 'classnames';
import React, { useState, useRef, useMemo, useCallback } from 'react';
import useFeatureFlags from './feature-flags/hook';
import * as portals from 'react-reverse-portal';

import { FullscreenPreviewModal } from './FullscreenPreviewModal';
import ImageSlider from './imageslider/ImageSlider';

function ImageSlideViewer({ name, url, imageSources, onDocumentLoad, onPageChange }) {
  const fullscreenModalOpenerRef = useRef();
  const featureFlags = useFeatureFlags();
  const contentContainerRef = useRef();

  const portalNode = useMemo(
    () =>
      portals.createHtmlPortalNode({
        attributes: { class: 'flex w-full h-full' },
      }),
    []
  );
  const [customFullscreenOpen, setCustomFullscreenOpen] = useState(false);

  const openCustomFullscreenCallback = useCallback(() => {
    if (fullscreenModalOpenerRef.current) {
      setCustomFullscreenOpen(true);
      fullscreenModalOpenerRef.current();
    }
  }, []);

  return (
    <div
      ref={contentContainerRef}
      className={classNames('flex w-full h-full bg-bedrock-light-gray rounded-md overflow-hidden')}
    >
      <portals.InPortal node={portalNode}>
        <ImageSlider
          imageSources={imageSources}
          onLoad={onDocumentLoad}
          onSlideChange={onPageChange}
          contentContainerRef={contentContainerRef}
          downloadUrl={featureFlags?.allow_pdf_downloads ? url : undefined}
          openCustomFullscreenCallback={openCustomFullscreenCallback}
          customFullscreenOpen={customFullscreenOpen}
        />
      </portals.InPortal>
      {!customFullscreenOpen && (
        <portals.OutPortal
          node={portalNode}
          imageSources={imageSources}
          onLoad={onDocumentLoad}
          onSlideChange={onPageChange}
          contentContainerRef={contentContainerRef}
          downloadUrl={featureFlags?.allow_pdf_downloads ? url : undefined}
          openCustomFullscreenCallback={openCustomFullscreenCallback}
          customFullscreenOpen={customFullscreenOpen}
        />
      )}
      <FullscreenPreviewModal openRef={fullscreenModalOpenerRef} onClose={() => setCustomFullscreenOpen(false)}>
        {customFullscreenOpen && (
          <portals.OutPortal
            node={portalNode}
            imageSources={imageSources}
            onLoad={onDocumentLoad}
            onSlideChange={onPageChange}
            contentContainerRef={contentContainerRef}
            downloadUrl={featureFlags?.allow_pdf_downloads ? url : undefined}
            openCustomFullscreenCallback={openCustomFullscreenCallback}
            customFullscreenOpen={customFullscreenOpen}
          />
        )}
      </FullscreenPreviewModal>
    </div>
  );
}

export default ImageSlideViewer;
